import React from 'react';

const ElfImage = React.forwardRef(function WishElfImage({ image, id }, ref) {
  return (
    <div className={'wish__image'} ref={ref}>
      <img src={image} className={'wish__image-img'} />
    </div>
  );
});
export default ElfImage;
